"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailsColumn = void 0;
var Utilities_1 = require("../../Utilities");
var DetailsColumn_base_1 = require("./DetailsColumn.base");
var DetailsColumn_styles_1 = require("./DetailsColumn.styles");
exports.DetailsColumn = Utilities_1.styled(DetailsColumn_base_1.DetailsColumnBase, DetailsColumn_styles_1.getStyles, undefined, { scope: 'DetailsColumn' });
//# sourceMappingURL=DetailsColumn.js.map